// Ida e volta da tela de dados bancários do prestador (`/e/bank`). Os atalhos
// "Adicionar dados bancários" (notas, detalhe do pagamento, aba Pagamentos do
// contrato) mandam a rota atual em `?voltar=`, e a tela volta para ela depois de salvar.

const BANK_ROUTE = "/e/bank";

/** Rota dos dados bancários com a volta para a tela atual (`location` do react-router). */
export function bankDataRoute(location) {
  const back = location ? `${location.pathname}${location.search || ""}` : "";
  return back ? `${BANK_ROUTE}?voltar=${encodeURIComponent(back)}` : BANK_ROUTE;
}

/**
 * Para onde voltar depois de salvar, lido do `?voltar=`. Só aceita uma rota da visão do
 * colaborador (`/e/...`), para o parâmetro não levar a outro site; senão, `null`.
 */
export function bankDataReturnPath(search) {
  const back = new URLSearchParams(search || "").get("voltar");
  if (!back || !back.startsWith("/e/") || back.startsWith(BANK_ROUTE)) return null;
  return back;
}

/**
 * Atualiza o `bankData` do usuário guardado no login (`user_ow`), que as telas do
 * prestador leem para liberar o envio de nota. Sem isso, o envio seguiria bloqueado
 * até recarregar a página.
 */
export function storeBankData(bankData) {
  try {
    const user = JSON.parse(localStorage.getItem("user_ow") || "{}");
    localStorage.setItem("user_ow", JSON.stringify({ ...user, bankData: { ...(user.bankData || {}), ...bankData } }));
  } catch (err) {
    console.error(err);
  }
}
